module.exports = __webpack_public_path__ + "img/puppy-what-we-do-1.7025b98b.png";